var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMeeting = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: "100%",
    viewBox: "0 0 512 512",
    width: "100%",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m181 346c0-24.813-20.187-45-45-45s-45 20.187-45 45 20.187 45 45 45 45-20.187 45-45zm-45 15c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 466v15h390v-15c0-41.355-33.645-75-75-75-24.508 0-46.306 11.818-60 30.052-13.694-18.234-35.492-30.052-60-30.052s-46.306 11.818-60 30.052c-13.694-18.234-35.492-30.052-60-30.052-41.355 0-75 33.645-75 75zm315-45c19.557 0 36.239 12.539 42.43 30h-84.86c6.191-17.461 22.873-30 42.43-30zm-120 0c19.557 0 36.239 12.539 42.43 30h-84.86c6.191-17.461 22.873-30 42.43-30zm-120 0c19.557 0 36.239 12.539 42.43 30h-84.86c6.191-17.461 22.873-30 42.43-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 346c0-24.813-20.187-45-45-45s-45 20.187-45 45 20.187 45 45 45 45-20.187 45-45zm-45 15c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421 346c0-24.813-20.187-45-45-45s-45 20.187-45 45 20.187 45 45 45 45-20.187 45-45zm-45 15c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 259.541 39.271-78.541h161.459l39.27 78.541 39.271-78.541h96.729v-150h-512v150h96.729zm-106-198.541h452v90h-85.271l-20.729 41.459-20.729-41.459h-198.542l-20.729 41.459-20.729-41.459h-85.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121 91h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 91h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361 91h30v30h-30z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMeeting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/meeting.8c165709.svg";
export { ForwardRef as ReactComponent };